  export const intitalQuestion = [
    {
      questionName: "Is this package designed for someone that owns a business?",
      name: "isOwnsABusiness",
      value: "",
      options: [
        {
          label: "Yes",
          value: "Business",
        },
        {
          label: "No",
          value: "Individual",
        },
      ],
    },
    {
      questionName: "Should this package help with accounting?",
      name: "isWithAccounting",
      value: null,
      options: [
        {
          label: "Yes",
          value: "Accounting",
        },
        {
          label: "No",
          value: "",
        },
      ],
    },
    {
      questionName: "Should this package help with payroll?",
      name: "isWithPayroll",
      value: null,
      options: [
        {
          label: "Yes",
          value: "Payroll",
        },
        {
          label: "No",
          value: "",
        },
      ],
    },
    {
      questionName: "Should this package help someone start a new business?",
      name: "isForNewBusiness",
      value: null,
      options: [
        {
          label: "Yes",
          value: "New Business",
        },
        {
          label: "No",
          value: "",
        },
      ],
    },
    {
      questionName: "Should this package help with IRS issues?",
      name: "isForIRSIssues",
      value: null,
      options: [
        {
          label: "Yes",
          value: "IRS Issues",
        },
        {
          label: "No",
          value: "",
        },
      ],
    },
    {
      questionName: "Should this package provide strategic advisory help?",
      name: "isForStrategicAdvisory",
      value: null,
      options: [
        {
          label: "Yes",
          value: "Strategic Help",
        },
        {
          label: "No",
          value: "",
        },
      ],
    },
  ];
